export default __webpack_public_path__ + "static/media/amazonas2.42880c8d.jpg";